import {SubTitle} from "@FRAMEWORK/ui/desktop/text";
import * as style from "@COMPONENTS/style/detailpackage/promotionlink";
import useEventPromotion from "@QUERIES/prdt/event/useEventPromotion";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {memo} from "react";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import {useTaggingClick} from "@/hooks/common/useTagging";

const DetailPromotionComponent = ({evCd}: {evCd: string}) => {
	const useEvtPromotion = useEventPromotion(evCd);
	const promotionList = useEvtPromotion.data?.body || [];

	const {taggingClick} = useTaggingClick("pkg_select_promo_dtl", {selectDiv: "relatedBanner"});
	return (
		<>
			{promotionList.length > 0 && (
				<style.Wrap>
					<SubTitle>관련 기획전</SubTitle>
					<style.LinkList>
						{promotionList.map(({mstLink, mstNm}, index) => (
							<style.LinkListItem key={index}>
								<style.Link
									href="#"
									onClick={e => {
										e.preventDefault();
										taggingClick({link: mstLink, title: mstNm});
										location.href = `${publicRuntimeConfig.ENV_PACKAGE_URL}${mstLink}`;
									}}
								>
									<style.LinkTitle dangerouslySetInnerHTML={{__html: mstNm.replaceAll(/<br\s*\/?>/gi, "")}} />
									<style.LinkArrow>기획전 바로가기</style.LinkArrow>
								</style.Link>
							</style.LinkListItem>
						))}
					</style.LinkList>
				</style.Wrap>
			)}
		</>
	);
};

/** 관련 기획전*/
const DetailPromotion = (props: {evCd: string}) => (
	<ErrorBoundary logMsg="DetailPromotion Error">
		<DetailPromotionComponent {...props} />
	</ErrorBoundary>
);

export default memo(DetailPromotion);
